export const ORDER_ID_KEY = "swgy_checkout_order_id";
export const PAYMENT_CHECKOUT_STATE_KEY = "swgy_checkout_state_key";
export const PAYMENT_CHECKOUT_STATE_PAYLOAD_KEY = "swgy_checkout_state_payload";
export const IS_SWIGGY_MONEY_FLOW = "is_swiggy_money_flow";
export const SWIGGY_MONEY_PAYMENT_AMOUNT = "swiggy_money_payment_amount";
export const WALLET_PAYMENT_CHECK_KEY = "wallet_payment_check";
export const ORIGINAL_BUSINESS_LINE = "original_business_line";

export const SWIGGY_MONEY_PAYMENTS_RESPONSE_KEY = "sm_show_payments";
export const DEFAULT_PAYMENTS_RESPONSE_KEY = "show_payments";

export const SWIGGY_MONEY_JUSPAY_SDK_STATE = "sm_juspay_sdk_state";
export const DEFAULT_JUSPAY_SDK_STATE = "juspay_sdk_state";

export const SWIGGY_MONEY_MORE_BANKS_LIST_KEY = "sm_more_banks_list";
export const DEFAULT_MORE_BANKS_LIST_KEY = "more_banks_list";

export const SWIGGY_MONEY_UPI_INTENT_METHODS = "sm_upi_intent_available_methods";
export const TURBO_CHECKOUT_UPI_INTENT_METHODS = "turbo_upi_intent_available_methods";
export const DEFAULT_UPI_INTENT_METHODS = "upi_intent_available_methods";
export const PENNY_TXN_ID_KEY = "swgy_penny_txn_order_id";
export const PENNY_TXN_STATE_KEY = "swgy_penny_txn_state_key";
export const PENNY_TXN_STATE_PAYLOAD_KEY = "swgy_penny_txn_state_payload";

export const ASSURE_PAY_ALL_DUES_STORAGE_KEY = "assure_pay_all_dues";
export const GIFT_DETAILS_STORAGE_KEY = "gift-details";

export const SESSION_STORAGE_PAYMENT_LOADED = "hasPaymentLoadTimeRecorded";

export const SHOW_ONE_SPLITPAY_AT_A_TIME_TOAST = "show_one_splitpay_at_a_time";

export const SDK_TURBO_PLACE_ORDER_TIME = "sdk_turbo_place_order_time";
export const PLACE_ORDER_DATA = "place_order_data";

export enum APP_STORAGE_KEYS_FOR_INAPP_UPI_BANNER {
    INAPP_UPI_HALF_CARD_COUNT = "iau_half_card_count",
}
